import { convertMonth } from '@/helpers/convertMonth'
import classNames from 'classnames'
import moment, { Moment } from 'moment'
import { useTranslation } from 'react-i18next'
import s from './Calendar.module.scss'

const CalendarDates = ({
    today,
    targetDate,
    startDay,
    currentList,
    prevMonth,
    nextMonth,
    setTargetDate,
    setCurrentList,
    eventsDefault,
    lightTheme = false
}) => {
    // const [selectedDate, setSelectedDate] = useState(null)
    const { i18n, t } = useTranslation()
    const totalDays = 35
    const day = startDay.clone().subtract(1, 'day')
    const daysArray = [...Array(totalDays)]?.map(() => day.add(1, 'day').clone())
    const isCurrentDay = day => moment().isSame(day, 'day')
    const isCurrentMonth = day => today.isSame(day, 'month')
    const isSelectedDate = day => targetDate !== null && targetDate.isSame(day, 'day')

    const isDateMarked = (day: Moment) => {
        return eventsDefault?.some(event => {
            const eventDateFrom = moment(event.dateFrom)
            const eventDateTo = moment(event.dateTo)
            if (event.dateTo > new Date()) {
                return eventDateFrom.isSameOrBefore(day) && eventDateTo.isSameOrAfter(day)
            }
            return false
        })
    }

    const selectDate = day => {
        if (targetDate !== null && targetDate.isSame(day, 'day')) {
            // setSelectedDate(null)
            setTargetDate(null)
            setCurrentList(eventsDefault)
        } else {
            // setSelectedDate(day)
            setTargetDate(day)
            setCurrentList(
                eventsDefault?.filter(event => {
                    const eventDateFrom = moment(event.dateFrom)
                    const eventDateTo = moment(event.dateTo)

                    return eventDateFrom.isSameOrBefore(day) && eventDateTo.isSameOrAfter(day)
                })
            )
        }
    }

    return (
        <div className={`calendar__dates ${lightTheme ? s.lightWrapper : ''}`}>
            <div className='calendar__dates-head'>
                {i18n.language === 'en' ? (
                    <span className={classNames('calendar__dates-month', lightTheme ? s.lightMonth : '')}>
                        {today.format('MMMM')}, {today.format('YYYY')}
                    </span>
                ) : (
                    <span className={classNames('calendar__dates-month', lightTheme ? s.lightMonth : '')}>
                        {convertMonth(today.format('MMMM'), false)}, {today.format('YYYY')}
                    </span>
                )}
                <div className='calendar__dates-nav'>
                    <button
                        onClick={prevMonth}
                        className={classNames('calendar__dates-arrow', lightTheme ? s.dateArrows : '')}
                    >
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M12 6L8.05905 10.4336C8.02538 10.4715 8.02538 10.5285 8.05905 10.5664L12 15'
                                stroke={lightTheme ? '#a9b4d1' : '#A9B4D1'}
                                strokeWidth='2'
                                strokeLinecap='round'
                            />
                        </svg>
                    </button>
                    <button
                        onClick={nextMonth}
                        className={classNames('calendar__dates-arrow', lightTheme ? s.dateArrows : '')}
                    >
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                stroke={lightTheme ? '#a9b4d1' : '#A9B4D1'}
                                strokeWidth='2'
                                strokeLinecap='round'
                            />
                        </svg>
                    </button>
                </div>
            </div>
            <div className='calendar__dates-grid'>
                {daysArray?.map(date => (
                    <div
                        onClick={() => isDateMarked(date) && isCurrentMonth(date) && selectDate(date)}
                        key={date.format('DDMMYYYY')}
                        className={
                            'calendar__date ' +
                            (isCurrentDay(date) ? 'calendar__date_today ' + (lightTheme ? s.lightToday : '') : '') +
                            (isSelectedDate(date) ? ' calendar__date_selected' : '') +
                            (isCurrentMonth(date) ? ' calendar__date_current' : '') +
                            (isDateMarked(date) ? ' calendar__date_marked' : '')
                        }
                    >
                        <p className={classNames(`calendar__date-num`, lightTheme ? s.dateNumLight : '')}>
                            {date.format('D')}
                        </p>
                        {isDateMarked(date) && (
                            <div className={classNames('calendar__date-dot', lightTheme ? s.dateDotLight : '')}></div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CalendarDates
